<template>
  <v-app>
    <v-main>
      <v-container fluid class="d-flex justify-center align-start fill-height pa-0 login-background">

            <v-card class="my-0 mx-0 pa-0 mt-sm-4" min-width="300" width="500" max-width="500" flat tile>
              <v-card-title class="loginhead py-0 px-3 black orange--text text--lighten-1 text-caption d-flex align-content-end">
                <div></div>
              </v-card-title>
              <v-card-text class="pt-5 grey darken-4 white--text">
                <div v-if="mode=='passwort_vergessen'">
                  <v-text-field hide-details autocomplete="off" dark persistent-placeholder v-model="email" label="E-Mail" outlined dense clearable></v-text-field>
                  <div class="errormsg my-2">
                    <div v-if="email_error" class="text-center red--text text-caption">Leider konnten wir unter dieser Mailadresse<br />keine relevanten Daten finden.</div>
                    <div v-if="email_ok" class="text-center text--lighten-2 green--text text-caption">Wir haben eine E-Mail an die angegebene Adresse geschickt.<br />Bitte folgen sie den Anweisungen in der E-Mail.</div>
                  </div>
                  <v-btn color="primary" @click="passwort_vergessen" dense block>Passwort zusenden</v-btn>
                  <div class="text-center mt-5 text-caption"><v-btn color="secondary" class="text-none" @click="mode='login'" x-small>zurück zum Login</v-btn></div>
                </div>
                <div v-else>
                  <v-text-field class="mb-3" hide-details autocomplete="off" dark v-model="user" persistent-placeholder placeholder=" " ref="user" label="User" outlined dense @keydown.enter="$refs.pwd.focus()" clearable></v-text-field>
                  <v-text-field class="mb-3" hide-details autocomplete="off" dark v-model="pwd" persistent-placeholder  ref="pwd" label="Passwort" @keydown.enter="login" :append-icon="anzeigen ? 'mdi-eye' : 'mdi-eye-off'" :type="anzeigen ? 'text' : 'password'" @click:append="anzeigen = !anzeigen" outlined dense clearable></v-text-field>
                  <div class="errormsg mt-5">
                    <div class="text-center red--text text-caption" v-html="login_error ? 'Anmeldung fehlgeschlagen' : '&nbsp'"></div>
                  </div>
                  <v-btn color="primary" @click="login" dense block>Login</v-btn>
                  <div v-if="is2FAenabled" class="mt-3">
                    <div class="d-flex pl-10 mb-3">
                      <img style="max-width: 36px; width: 36px; border:1px solid #ccc; border-radius:5px; vertical-align: bottom;" class="white mr-4" src="https://db.feuerwehrdatenbank.de/images/Google_Authenticator.png">
                      <div class="text-caption">Geben sie hier den 6-stelligen Code<br />von Google-Authenticator ein:</div>
                    </div>
                    <div class="ma-auto position-relative" style="max-width: 300px">  
                      <v-otp-input v-model="otp" ref="otpInput" :disabled="loading2" @finish="onOTPDone"></v-otp-input>
                      <v-overlay absolute :value="loading2">
                        <v-progress-circular indeterminate color="white" :width="5" :size="70"></v-progress-circular>
                      </v-overlay>
                    </div>
                    <div v-show="otp_invalid" class="text-center red--text text-caption">Validierung fehlgeschlagen,<br />bitte geben sie den aktuellen Code ein.</div>
                  </div>
                  <div class="text-center mt-5 text-caption"><v-btn color="secondary" class="text-none" @click="mode='passwort_vergessen'" x-small>Passwort vergessen</v-btn></div>
                  
                </div>
                <div v-if="appInstallEnabled" class="text-center mt-3 text-caption">
                  <a :title="getAppInstall('userAgent')" target="_blank" :href="getAppInstall('url')"><img style='width:70px' :src="getAppInstall('icon')" /></a>
                </div>

                <div class="text-center mt-3 text-caption">
                  <div>Die Verarbeitung der persönlichen Daten erfolgt im<br />Rahmen der EU-DSGVO und unserer</div>
                  <div><a class="white--text" href="https://www.feuerwehrdatenbank.de/datenschutz.html" target="_blank">Datenschutzerklärung</a></div>
                </div>
              </v-card-text>
            </v-card>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>

import axios from 'axios';
import { AUTH_REQUEST } from "@/store/actions/auth";
//import {version} from './../package'

export default {
  name: 'login',
  mixins:[],
  data: () => ({
    mode: "login",
    user: "",
    pwd: "",
    email: "",
    umgebung: "https://app2.feuerwehrdatenbank.de/",
    anzeigen: false,
    loading: true,
    loading2: false,
    otp: "",
    otp_invalid: false,
    is2FAenabled: false,
    login_error: false,
    email_ok: false,
    email_error: false,
    appInstallEnabled: false,
  }),
  created(){
    this.apiurl = process.env.VUE_APP_APIURL;
    if (process.env.VUE_APP_APIAUTHORIZATION){
      axios.defaults.headers.common['Authorization'] = '' // process.env.VUE_APP_APIAUTHORIZATION
    }else if(window.SID){
      axios.defaults.headers.common['SID'] = window.SID
    }   
    axios.defaults.withCredentials = true;
  },
  mounted(){

  },
  methods:{
    login() {
      this.loading = true
      this.login_error = false;
      axios.post(this.umgebung+'api/v2/user/is2FAenabled',{"user": this.user, "pwd": this.pwd })
        .then(r => {
          if (!r.data.result){
            //  2FA ist aus
            this.is2FAenabled = false
            this.$store.dispatch(AUTH_REQUEST, {"user": this.user, "pwd": this.pwd })
            .then(r => {
                if (r.data.token){
                  //console.log(r)
                  this.forward()
                }else{
                  this.login_error = true;
                }
                this.loading = false
              }).catch((e) => {
                console.error(e);
                this.loading = false
                this.login_error = true;
              })
          }else{
            this.is2FAenabled = true
            if (this.otp){
              this.login_error = false
              this.loading2 = true
              this.otp_invalid = false

                this.$store.dispatch(AUTH_REQUEST, {"user": this.user, "pwd": this.pwd, "code": this.otp })
                    .then(r => {
                        if (r.data.token){
                            this.forward()
                        }else{
                            this.otp_invalid = true
                            this.otp = ""
                            this.$nextTick(() => {
                            this.$refs.otpInput.focus();
                            });
                        }
                        this.loading = false
                        this.loading2 = false
                    }).catch((e) => {
                        console.error(e);
                        this.otp_invalid = true
                        this.otp = ""
                        this.$nextTick(() => {
                            this.$refs.otpInput.focus();
                        });
                        this.loading = false
                        this.loading2 = false
                    })

            }else{
              this.$nextTick(() => {
                this.$refs.otpInput.focus();
              });
            }

          }
        }).catch(function(e){
          console.error(e);
        })
    },
    onOTPDone() {
      this.login();
    },
    forward(){
        this.$router.push('/')
      //window.location.href = window.screen.width<600 ? this.umgebung+'?mobile=1' : this.umgebung
      //console.log('eingeloggt')
    },
    passwort_vergessen() {
      this.loading = true
      this.email_ok = false
      this.email_error = false
      axios.post(this.apiurl+'user/passwort_vergessen',{"email": this.email})
        .then(r => {
          if (r.data.result){
            this.email_ok = true
          }else{
            this.email_error = true
          }
          console.log(r.data.result)
          this.loading = false
        }).catch((e) => {
          this.email_error = true
          console.error(e);
          this.loading = false
        })
    },
    /*
    getAppInstall(prop){
      let icon = require("@/assets/appstore.png")
      if (navigator.userAgent.indexOf("android")>=0) icon = require("@/assets/playstore.png")
      let d = { "userAgent": navigator.userAgent, "icon": icon, "url": "https://app2.feuerwehrdatenbank.de" }
      return d[prop]
    }
      */
  },
  watch: {
      'mode': {
        handler: function () {
          this.email_ok = false
          this.email_error = false
          this.login_error = false
        },
        deep: true
      },
  }
};
</script>
<style>

input {
  color: white;
}
input:-webkit-autofill {
  -webkit-text-fill-color: white !important; /* autofill-Schriftfarbe */
  box-shadow: 0 0 0 1000px transparent inset !important;
  transition: background-color 9999s ease-in-out 0s !important;
  caret-color: white;
}

</style>
<style scoped>
.errormsg{
  min-height: 32px;
}
.errormsg>div{
  line-height: 1rem !important;
}
.login-background{
  background-color: #000000;
}
.v-card__title{
  word-break: normal !important;
}
.loginhead{
  background-image: url('https://db.feuerwehrdatenbank.de/images/logo_266x80.jpg');  
  background-position: center center;
  height: 95px;
}
</style>
